
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/402bfac5de8a4bb997112a9f3d45d4d7.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto w-full">
        <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-white/80 mb-4 sm:mb-6">
          For Men & Women
        </div>
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 sm:mb-6 lg:mb-8">
          Enhance Your Natural<br />Beauty While You Sleep
        </h1>
        <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-8 sm:mb-10 lg:mb-12 max-w-2xl mx-auto leading-relaxed">
          Improve your facial aesthetics, support better breathing, and wake up looking your best. Premium products designed for everyone.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Link
            to="/product/jawline-support-strap"
            className="w-full sm:w-auto bg-white text-black h-12 sm:h-14 px-8 sm:px-10 rounded-full text-sm sm:text-base font-medium hover:bg-white/90 transition-all flex items-center justify-center cursor-pointer whitespace-nowrap"
          >
            Shop Now
          </Link>
          <a
            href="#how-it-works"
            className="w-full sm:w-auto border-2 border-white text-white h-12 sm:h-14 px-8 sm:px-10 rounded-full text-sm sm:text-base font-medium hover:bg-white/10 transition-all flex items-center justify-center cursor-pointer whitespace-nowrap"
          >
            Learn More
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl sm:text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
